import React from "react";
import CheckCircleOutlineOutlined from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { lighten, useTheme } from "@mui/material/styles";

type AlertType = "info" | "warning" | "error" | "success";

interface AlertProps {
  type?: AlertType;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const iconMap: Record<AlertType, React.ReactNode> = {
  info: <InfoOutlined fontSize="small" />,
  warning: <WarningAmberOutlined fontSize="small" />,
  error: <ErrorOutlineOutlined fontSize="small" />,
  success: <CheckCircleOutlineOutlined fontSize="small" />,
};

export const Alert: React.FC<AlertProps> = ({ type = "info", children, className, style }) => {
  const theme = useTheme();
  const color = theme.palette[type].main;
  const bgColor = lighten(color, 0.9);

  return (
    <div
      style={{
        border: `1px solid ${color}`,
        borderLeft: "none",
        borderRight: "none",
        borderRadius: 0,
        backgroundColor: bgColor,
        ...style,
      }}
      className={`px-24 py-1 items-center flex${className ? ` ${className}` : ""}`}
    >
      <span className="mr-2" style={{ color }}>
        {iconMap[type]}
      </span>
      {children}
    </div>
  );
};
